import script from "./gyjg.vue?vue&type=script&setup=true&lang=js"
export * from "./gyjg.vue?vue&type=script&setup=true&lang=js"

import "./gyjg.vue?vue&type=style&index=0&id=44eaf396&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44eaf396"]])

export default __exports__